"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconStar = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M49.53 64.29a6.94 6.94 0 0 1-3.23-.8l-9.46-5a3.94 3.94 0 0 0-3.66 0l-9.46 5a6.94 6.94 0 0 1-10.07-7.31l1.81-10.54a3.93 3.93 0 0 0-1.13-3.48l-7.67-7.47a6.94 6.94 0 0 1 3.84-11.83l10.58-1.54a3.93 3.93 0 0 0 3-2.15l4.73-9.59a6.94 6.94 0 0 1 12.44 0L46 19.16a3.94 3.94 0 0 0 3 2.15l10.5 1.55a6.94 6.94 0 0 1 3.84 11.83l-7.66 7.46a3.94 3.94 0 0 0-1.13 3.49l1.81 10.54a7 7 0 0 1-6.83 8.12zM35 8.71a3.86 3.86 0 0 0-3.53 2.19l-4.73 9.59a6.94 6.94 0 0 1-5.22 3.79l-10.58 1.54a3.94 3.94 0 0 0-2.18 6.71L16.41 40a6.94 6.94 0 0 1 2 6.14L16.6 56.68a3.94 3.94 0 0 0 5.71 4.15l9.46-5a6.93 6.93 0 0 1 6.46 0l9.46 5a3.94 3.94 0 0 0 5.71-4.15l-1.8-10.54a6.94 6.94 0 0 1 2-6.14l7.66-7.46a3.94 3.94 0 0 0-2.18-6.71l-10.6-1.54a6.94 6.94 0 0 1-5.22-3.79l-4.73-9.59A3.86 3.86 0 0 0 35 8.71z"
  })),
  height: undefined,
  width: undefined
});
IconStar.displayName = 'IconStar';
var _default = IconStar;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/star.js
// module id = 596
// module chunks = 0